'use strict';
import * as $j_app$002epages$002e$002dApp$002dPage$002dInit$0024$002dLogout$002dError from "./app.pages.-App-Page-Init$-Logout-Error.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_pages_AppPageInit$LogoutError$ServerError(error) {
  this.Lapp_pages_AppPageInit$LogoutError$ServerError__f_error = null;
  this.Lapp_pages_AppPageInit$LogoutError$ServerError__f_error = error;
}
export { $c_Lapp_pages_AppPageInit$LogoutError$ServerError as $c_Lapp_pages_AppPageInit$LogoutError$ServerError };
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype = new $j_app$002epages$002e$002dApp$002dPage$002dInit$0024$002dLogout$002dError.$h_Lapp_pages_AppPageInit$LogoutError();
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.constructor = $c_Lapp_pages_AppPageInit$LogoutError$ServerError;
/** @constructor */
function $h_Lapp_pages_AppPageInit$LogoutError$ServerError() {
}
export { $h_Lapp_pages_AppPageInit$LogoutError$ServerError as $h_Lapp_pages_AppPageInit$LogoutError$ServerError };
$h_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype = $c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype;
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 899629227, true);
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_pages_AppPageInit$LogoutError$ServerError)) {
    var x = this.Lapp_pages_AppPageInit$LogoutError$ServerError__f_error;
    var x$2 = x$0.Lapp_pages_AppPageInit$LogoutError$ServerError__f_error;
    return ((x === null) ? (x$2 === null) : x.equals__O__Z(x$2));
  } else {
    return false;
  }
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.productPrefix__T = (function() {
  return "ServerError";
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_pages_AppPageInit$LogoutError$ServerError__f_error;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "error";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_pages_AppPageInit$LogoutError$ServerError.prototype.ordinal__I = (function() {
  return 0;
});
function $isArrayOf_Lapp_pages_AppPageInit$LogoutError$ServerError(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_pages_AppPageInit$LogoutError$ServerError)));
}
export { $isArrayOf_Lapp_pages_AppPageInit$LogoutError$ServerError as $isArrayOf_Lapp_pages_AppPageInit$LogoutError$ServerError };
var $d_Lapp_pages_AppPageInit$LogoutError$ServerError = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_pages_AppPageInit$LogoutError$ServerError, "app.pages.AppPageInit$LogoutError$ServerError", ({
  Lapp_pages_AppPageInit$LogoutError$ServerError: 1,
  Lapp_pages_AppPageInit$LogoutError: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1,
  s_reflect_Enum: 1
}));
export { $d_Lapp_pages_AppPageInit$LogoutError$ServerError as $d_Lapp_pages_AppPageInit$LogoutError$ServerError };
//# sourceMappingURL=app.pages.-App-Page-Init$-Logout-Error$-Server-Error.js.map
